export const breakpoints = {
    values: {
        xs: 0,
        sm: 768,
        // default mui settings
        md: 900,
        lg: 1200,
        xl: 1536,
    },
};
